// Translations
import tosDialog from '../components/tos-dialog/translations/tr'

// Translation: Register > Landing > Form (Turkish)
export default Object.freeze({
	components: { tosDialog },
	form: {
		actions: {
			continue: 'Devam et',
			register: 'Kayıt ol'
		},
		fields: {
			email: {
				placeholder: 'E-postanızı girin'
			},
			firstName: {
				placeholder: 'Adınızı girin'
			},
			lastName: {
				placeholder: 'Soyadınızı girin'
			},
			password: {
				placeholder: 'Şifrenizi girin'
			},
			passwordConfirmation: {
				placeholder: 'Şifrenizi yeniden girin'
			}
		},
		options: {
			login: {
				action: 'Giriş yap',
				label: 'Zaten kayıtlı mısın?'
			}
		},
		title: {
			accountInformation: 'Hesap bilgileri',
			profileDetails: 'Profil detayları'
		}
	}
})
